<template>
	<div>
		<NuxtPwaManifest />
		<NuxtLayout>
			<template #default>
				<NuxtPage />
				<Toast />
			</template>
		</NuxtLayout>
	</div>
</template>

<script setup>
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'
import { provideUseId } from '@headlessui/vue'
import { useAuth } from '@/composables/useAuth'
import { isAccountPortal } from '@/composables/useIsAccountPortal'

const { $intercom } = useNuxtApp()
const { intercomSettings } = useAuth()

// #TODO: Revisit when we updgrade to vue ^=3.5 https://github.com/tailwindlabs/headlessui/issues/2913
provideUseId(() => useId())

const { locale } = useI18n()

useHead({
	htmlAttrs: [
		{
			lang: () => {
				return locale.value
			}
		}
	]
})

watch(isAccountPortal, () => {
	if ($intercom?.isReady()) {
		$intercom?.update(intercomSettings.value)
	}
}, { immediate: true })
</script>
